/**
 * @file
 * Dropdown navigation.
 */
import Choices from "choices.js";

((Choices, options) => {
  /**
   * Navigates to the given URL.
   *
   * @param {string} url
   *   The url to be navigated to.
   */
  function navigate(url) {
    if (url !== "") {
      window.location = url;
    }
  }

  /**
   * Initializes the dropdown navigations.
   */
  function init() {
    const dropdowns = document.querySelectorAll(".js-dropdown--nav select");

    dropdowns.forEach((dropdown) => {
      const instance = new Choices(dropdown, options);

      instance.passedElement.element.addEventListener(
        "choice",
        (event) => {
          navigate(event.detail.value);
        },
        false
      );
      dropdown.classList.add("is-hidden");
    });
  }

  init();
})(window.Choices = Choices, window.dropdownOptions);
